import type { CareInstruction as TCareInstruction } from '@frontend/libs/types/product'
import type React from 'react'

import { ImageSize } from '@frontend/libs/types/media'
import { parseHtml } from '@frontend/libs/utils'
// import handWash from '@images/hand-wash.png';
import { Accordion, AccordionItem, Image } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

export type CareInstructionProps = TCareInstruction

export function CareInstruction({
  icon,
  precautions,
  title,
}: Readonly<CareInstructionProps>): React.JSX.Element {
  return (
    <Accordion
      className="px-0"
      isCompact
      itemClasses={{
        content: 'pt-6',
        title: 'text-sm uppercase font-medium',
        trigger: 'p-0',
      }}
    >
      <AccordionItem
        aria-label={__('Fabric and care')}
        key={`careInstruction`}
        title={__('Fabric and care')}
      >
        <div className="space-y-6 text-sm uppercase">
          {title && (
            <div>
              <h4 className="mb-2 font-medium">{__('Care Instructions')}</h4>
              {icon && (
                <Image
                  alt={title}
                  className="mb-2"
                  height={50}
                  src={icon.sizes[ImageSize.Full]}
                  width={50}
                />
              )}
              <p>{title}</p>
            </div>
          )}
          {precautions && (
            <div>
              <h4 className="mb-2 font-medium">{__('Precautions')}</h4>
              <div className="precautions">{parseHtml(precautions)}</div>
            </div>
          )}
        </div>
      </AccordionItem>
    </Accordion>
  )
}

export default CareInstruction
